<template>
  <div class="header-logo">
    <div class="header-logo__inner">
      <a class="header-logo__link" :aria-label="langJson[lang].logoText" href="/">
        <div class="header-logo__image"></div>
      </a>
      <span class="header-logo__text">{{ langJson[lang].logoText }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  const mainStore = useMainStore();
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);
</script>
